import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetEcrFileInformationsResData } from "./GetEcrFileInformationsResData";

const ENDPOINT = "/fitness_statistics/ecr_file_informations";

export class GetEcrFileInformationsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetEcrFileInformationsResData> {
        var res = await this.executeCommand(null, null);
        return new GetEcrFileInformationsResData(res);
    }
}
